import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

export const CTA = () => {
  return (
    <section data-testid="cta-section" className="py-24 md:py-32 bg-[#0A0A0A] relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(7,209,131,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(7,209,131,0.03)_1px,transparent_1px)] bg-[size:64px_64px]" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-primary/10 rounded-full blur-[120px] pointer-events-none" />

      <div className="max-w-4xl mx-auto px-6 md:px-12 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          {/* Headline */}
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-semibold tracking-tight mb-6" data-testid="cta-headline">
            AZAV-Zulassung geplant oder{' '}
            <span className="text-primary">Audit vor der Tür?</span>
          </h2>

          {/* Description */}
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed max-w-2xl mx-auto mb-10" data-testid="cta-description">
            Lassen Sie uns kurz über Ihre Situation sprechen.
            Sie erhalten eine klare Einschätzung und einen konkreten Fahrplan.
          </p>

          {/* CTA Button */}
          <Link to="/kontakt">
            <Button 
              data-testid="cta-primary-button"
              className="bg-primary hover:bg-[#05b873] text-black font-semibold rounded-lg px-8 py-6 text-lg transition-all duration-300"
            >
              Kostenlose Ersteinschätzung vereinbaren
            </Button>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};
